export const SURVEY_SUBMIT_SUCCESS_TITLE = 'Successful'

export const SURVEY_SUBMIT_SUCCESS_BODY = 'Your Survey submitted successfully!'

export const SURVEY_SUBMIT_SUCCESS_OK = 'Ok'

export const SURVEY_COMPLETE_TITLE = 'Survey Complete!'

/** Return visit after a prior submission — no reward actions. */
export const SURVEY_ALREADY_SUBMITTED_TITLE = "You've Already Submitted"

export const SURVEY_ALREADY_SUBMITTED_SUBTITLE =
  'Thank you for your participation. Your responses were recorded.'

export const SURVEY_COMPLETE_THANK_YOU = 'Thank you for your participation'

export const SURVEY_COMPLETE_NO_REWARD_THANK_YOU =
  'Thank you for completing this survey!'

/** TC-SPW-55 / Figma 5074-14001 — "You Earned $[X]!" */
export function surveyCompleteEarnedHeading(display: string): string {
  return `You Earned ${display}!`
}

export const SURVEY_COMPLETE_REWARD_BODY =
  'Congratulations! Your reward is ready to claim'

export const SURVEY_COMPLETE_CLAIM_NOW = 'Claim Now'

/** TC-SPW-58 — Return to Home */
export const SURVEY_COMPLETE_HOME = 'Return to Home'


/** BFP-1025 — signup-survey completion only (normal surveys keep copy above). */
export const SIGNUP_SURVEY_COMPLETE_SUBTITLE =
  'Complete identity verification to redeem your reward.'

export const SIGNUP_SURVEY_COMPLETE_REWARD_BODY =
  'Your reward will be credited after you pass identity verification.'

export const SURVEY_COMPLETE_START_EKYC = 'Start eKYC'

export const SURVEY_COMPLETE_REMIND_LATER = 'Remind Me Later'

/** Figma 75:2694 — guest (not signed up) survey-done screen. */
export const WEB_SURVEY_COMPLETE_CONGRATS = 'Congratulations!'

export function webSurveyCompleteEarnedLine(display: string): string {
  return `You've Earned ${display}`
}

export const WEB_SURVEY_COMPLETE_REWARD_BODY =
  'Complete the next 3 quick steps to claim your reward.'

export const WEB_SURVEY_COMPLETE_SIGN_UP = 'Sign Up'

export const WEB_SURVEY_COMPLETE_VERIFY_MOBILE = 'Continue to Verify Mobile'

export const WEB_SURVEY_COMPLETE_JOURNEY_TITLE = '3 Easy Steps to Claim Your Reward'

export const WEB_SURVEY_COMPLETE_PARTICIPATION =
  'Thank you for your participation. You’ve earn a reward!'
